export default {
  title: 'Zones & tripwires',
  description: 'Draw the areas and lines on this site that should be logged, and choose who gets alerted.',
  backToSite: 'Back to site',
  siteDetailButton: 'Zones & tripwires',
  zones: 'Zones',
  tripwires: 'Tripwires',
  addZone: 'Add zone',
  addTripwire: 'Add tripwire',
  noZones: 'No zones yet',
  noZonesMessage: 'A zone is a named area inside the site. Entering and leaving it is logged for every employee.',
  noTripwires: 'No tripwires yet',
  noTripwiresMessage: 'A tripwire is a line on the map. Crossing it is logged, with the direction.',
  drawingZone: 'Drawing a zone',
  drawingTripwire: 'Drawing a tripwire',
  corners: '{count} corners',
  drawHintZone: 'Click the map to add corners. At least 3 are needed; drag to adjust, right-click to remove.',
  drawHintTripwire: 'Click the map to add points along the line. At least 2 are needed. Side A is on the left as you draw.',
  next: 'Next',
  cancelDrawing: 'Cancel',
  shapeChanged: 'Shape changed',
  saveShape: 'Save shape',
  discardShape: 'Discard',
  editDetails: 'Details',
  deleteZoneTitle: 'Delete zone',
  deleteZoneMessage: 'Delete {name}? Its past events are kept, but nothing new will be logged.',
  deleteTripwireTitle: 'Delete tripwire',
  deleteTripwireMessage: 'Delete {name}? Its past crossings are kept, but nothing new will be logged.',
  zoneSaved: 'Zone saved.',
  tripwireSaved: 'Tripwire saved.',
  zoneDeleted: 'Zone deleted.',
  tripwireDeleted: 'Tripwire deleted.',
  newZone: 'New zone',
  newTripwire: 'New tripwire',
  editZone: 'Edit zone',
  editTripwire: 'Edit tripwire',
  name: 'Name',
  colour: 'Colour',
  trigger: 'Alert on',
  triggerEnter: 'Entering',
  triggerExit: 'Leaving',
  triggerBoth: 'Entering and leaving',
  triggerAToB: 'Crossing A → B only',
  triggerBToA: 'Crossing B → A only',
  triggerAny: 'Crossing either way',
  sideALabel: 'Side A name',
  sideBLabel: 'Side B name',
  sideHint: 'Side A is on the left when walking the line in the order it was drawn.',
  directionLegend: 'A → B means from {a} to {b}.',
  sideDefaultA: 'A',
  sideDefaultB: 'B',
  notifyEmployee: 'Also notify the employee',
  notifyEmployeeHint: 'They get a push on their own phone, e.g. "You entered Fuel bay".',
  activeCheckbox: 'Active',
  recipients: 'Alert recipients',
  recipientsHint: 'Admins, and site managers of this site. Each gets a push notification, an email, or both.',
  addRecipient: 'Add a recipient…',
  noRecipients: 'Nobody is alerted yet. Events are still logged.',
  push: 'Push',
  email: 'Email',
  noEmail: 'No email on file',
  remove: 'Remove',
  recipientsCount: '{count} alerted',
  nobodyAlerted: 'Nobody alerted',
  alertsOff: 'Logged only',
  inactive: 'Inactive',
  save: 'Save',
  saving: 'Saving…',
  invalidPolygon: 'The zone needs at least 3 corners and its edges must not cross.',
  invalidLine: 'The line needs at least 2 points and must not cross itself.',
  mapHint: 'Click a zone or line on the map to select it.',
  zoneEvents: 'Zone events',
  tripwireEvents: 'Tripwire crossings',
  colEmployee: 'Employee',
  colZone: 'Zone',
  colLine: 'Tripwire',
  colSite: 'Site',
  colEvent: 'Event',
  colDirection: 'Direction',
  colWhen: 'When',
  colAlert: 'Alert',
  entered: 'Entered',
  left: 'Left',
  alertedBadge: 'Alerted',
  loggedBadge: 'Logged',
  viewMap: 'Map',
  noZoneEvents: 'No zone events in this range',
  noZoneEventsMessage: 'Entering or leaving a zone is logged here once a paired phone streams its position on site.',
  noTripwireEvents: 'No crossings in this range',
  noTripwireEventsMessage: 'Crossing a tripwire is logged here, with the direction, once a paired phone streams its position on site.',
}
